import { Component } from 'preact'
import cx from 'classnames'
import { DraftCaption } from './components'

export default class MobileFooter extends Component {
  constructor(props) {
    super(props)

    this.state = {
      top: 0,
      bottom: 0,
      isVisible: false,
      isSticky: false,
    }

    this.recalculate = this.recalculate.bind(this)
    this.updateStickiness = this.updateStickiness.bind(this)
    this.openPaybar = this.openPaybar.bind(this)
    this.bindInnerEl = el => this.innerEl = el
  }

  componentDidMount() {
    $(document).on('appReady appResize', () => setTimeout(this.recalculate, 1000))
    $(document).on('appScroll appResize', this.updateStickiness)
  }

  recalculate() {
    this.setState({
      top: this.top,
      bottom: this.bottom,
      isVisible: true,
      isSticky: this.isSticky,
    })
  }

  updateStickiness() {
    this.setState({ isSticky: this.isSticky })
  }

  openPaybar() {
    document.querySelector('.newPaybar .stickyButton').click()
  }

  get webpage() {
    return this._webpage ||= document.querySelector('.js__webpage')
  }

  get form() {
    return this._form ||= document.querySelector('.burosferaVacancyForm')
  }

  get button() {
    return this._button ||= document.querySelector('.burosferaVacancyForm-button')
  }

  get relativeTop() {
    return window.application.currentScrollPosition + this.webpage.getBoundingClientRect().top
  }

  get top() {
    return this.relativeTop + this.form.getBoundingClientRect().top
  }

  get bottom() {
    const clientRect = this.button.getBoundingClientRect()

    return this.relativeTop + clientRect.top + clientRect.height
  }

  get isSticky() {
    if (!this.innerEl) return false

    const innerElBottom = this.innerEl.getBoundingClientRect().bottom

    return Math.abs(innerElBottom - window.innerHeight) < 1
  }

  get shaftStyles() {
    const { top, bottom } = this

    return { height: (bottom - top) + 'px' }
  }

  render() {
    if (!this.state.isVisible) return null

    return (
      <div className="burosferaVacancyForm-stickyShaft" style={ this.shaftStyles }>
        <div className={ cx('module bottomStickyModule is__slim', { is__sticky: this.state.isSticky }) } ref={ this.bindInnerEl }>
          <div className="burosferaVacancyForm-footer">
            <DraftCaption />
            <button className="stickyButton is__publication" onClick={ this.openPaybar }>
              { I18n.t('newPaybar.buyButtonText.vacancy.default') }
            </button>
          </div>
        </div>
      </div>
    )
  }
}
